export const loaded = new Promise((resolve, reject) => { // eslint-disable-line no-unused-vars
    if(typeof window === 'undefined') {
        // Do nothing if run from server-side
        return;
    }

    window['vueGoogleMapsInit'] = resolve;
});


export const load = (apiKey, version) => {
    if(typeof document === 'undefined') {
        // Do nothing if run from server-side
        return;
    }

    let baseUrl = 'https://maps.googleapis.com';
    //No 'crossorigin' attribute because these are not CORS requests.
    const preConnect = document.createElement('link');
    preConnect.setAttribute('href', baseUrl);
    preConnect.setAttribute('rel', 'preconnect');
    document.head.appendChild(preConnect);

    // Minimal polyfill for isIntersecting
    if ('IntersectionObserver' in window &&
        'IntersectionObserverEntry' in window &&
        'intersectionRatio' in window.IntersectionObserverEntry.prototype &&
        !('isIntersecting' in IntersectionObserverEntry.prototype)) {

        Object.defineProperty(window.IntersectionObserverEntry.prototype, 'isIntersecting', {
            get: function () {
                return this.intersectionRatio > 0
            }
        })
    }

    // Load Google Maps only when intersecting the threshold (if supported)
    // otherwise just load it (and wait some longer...)
    if('IntersectionObserver' in window){
        const targetElement = document.getElementById('info-map');
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach(entry => {
                    if(entry.isIntersecting) {
                        startLoading();
                        observer.unobserve(entry.target);
                    }
                });
            },
            {
                rootMargin: '50% 0px 50% 0px'
            });
        observer.observe(targetElement);
    } else {
        startLoading();
    }

    function startLoading() {
        // Allow apiKey to be an object.
        // This is to support more esoteric means of loading Google Maps,
        // such as Google for business
        // https://developers.google.com/maps/documentation/javascript/get-api-key#premium-auth
        let options = {};

        if(typeof apiKey === 'string') {
            options.key = apiKey;
        } else if(typeof apiKey === 'object') {
            for(let k in apiKey) { // transfer values in apiKey to options
                options[k] = apiKey[k];
            }
        } else {
            throw new Error('apiKey should either be a string or an object');
        }

        options['callback'] = 'vueGoogleMapsInit';

        let url = baseUrl + '/maps/api/js?' +
            Object.keys(options)
                .map((key) => encodeURIComponent(key) + '=' + encodeURIComponent(options[key]))
                .join('&');

        if(version) {
            url = url + '&v=' + version;
        }

        const googleMapScript = document.createElement('script');
        googleMapScript.setAttribute('src', url);
        document.body.appendChild(googleMapScript);
    }
}
